import { z } from 'zod';

import { ATTACHMENT_MAX_FILES } from '../_types/attachment';

export function AttachmentSchema() {
	return z.object({
		id: z.string(),
		name: z.string(),
		size: z.number(),
		mimeType: z.string(),
		previewUrl: z.string(),
		status: z.enum(['uploading', 'success', 'error']),
		progress: z.number(),
		error: z.string().optional(),
		remoteId: z.string().optional()
	});
}

export function AttachmentsSectionSchema() {
	return z.object({
		attachments: z
			.array(AttachmentSchema())
			.max(ATTACHMENT_MAX_FILES)
			.default([])
	});
}

export type AttachmentsSectionValuesIn = z.input<
	ReturnType<typeof AttachmentsSectionSchema>
>;
